import {
  Alert,
  Box,
  Button,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import { FC, useState } from 'react';
import { useForm } from 'react-hook-form';

import LoadingButton from '../../../../shared/components/LoadingButton/LoadingButton';
import { VyseConfiguration as IVyseConfiguration } from '../../interfaces/Vyse';
import styles from './VyseConfiguration.module.scss';

interface VyseConfigurationProps {
  configs?: IVyseConfiguration;
  onUpdate: (configs: IVyseConfiguration) => Promise<void>;
  onClose: () => void;
}

const VyseConfiguration: FC<VyseConfigurationProps> = ({
  configs,
  onUpdate,
  onClose,
}) => {
  const {
    register,
    formState: { isValid, isSubmitting, isDirty, errors },
    handleSubmit,
  } = useForm<IVyseConfiguration>({
    defaultValues: configs,
  });
  const [error, setError] = useState<string | null>(null);

  const handleOnUpdate = (configs: IVyseConfiguration) => {
    setError(null);
    return onUpdate(configs).catch((error) => setError(error.message));
  };

  const handleOnClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <>
      <DialogContent dividers id={styles.vyseConfiguration}>
        {error && (
          <Alert severity='error' className={styles.alert}>
            {error}
          </Alert>
        )}
        <Box>
          <TextField
            fullWidth
            margin='normal'
            label='Url'
            {...register('url', {
              required: 'Url is required',
              pattern: {
                value:
                  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                message: 'Enter a valid URL',
              },
            })}
            error={!!errors.url}
            helperText={errors.url?.message}
          />
          <TextField
            fullWidth
            margin='normal'
            label='API Key'
            {...register('apiKey', {
              required: 'API is required',
            })}
            error={!!errors.apiKey}
            helperText={errors.apiKey?.message}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant='text'
          color='secondary'
          disabled={isSubmitting}
          onClick={handleOnClose}
        >
          Close
        </Button>
        <LoadingButton
          disabled={!isValid || !isDirty}
          loading={isSubmitting}
          onClick={handleSubmit(handleOnUpdate)}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </>
  );
};
export default VyseConfiguration;
